<div class="no-outlet">
  {{ 'PLEASE_SELECT_ATLEAST_ONE_OUTLET' | fallbackTranslate }}
</div>
